import { Alert, Stack } from "@mui/material";
import { useMemo } from "react";

import { VehicleVisualModelHelper } from "@/common/helpers/entity/vehicleVisualModel";
import { Mapper } from "@/common/mapping/mapper";
import {
  DamageDetectionDto,
  DamageDetectionItemDto,
  VehicleArea,
  VehicleProjection,
} from "@/core/api/generated/v1";

import { VisualModelSvgViewer, VisualModelSvgViewerProps } from "../VisualModelSvgViewer";

interface Props {
  damageDetection: DamageDetectionDto;
  item: DamageDetectionItemDto;
  visualModelSvgViewerProps?: Partial<VisualModelSvgViewerProps>;
}

export function VisualModelViewerOfDamageDetectionItem({
  damageDetection,
  item,
  visualModelSvgViewerProps,
}: Props) {
  const point = useMemo(
    () => Mapper.visualModel.mapDamageDetectionItemDtoToVisualModelPoint(item),
    [item],
  );

  return (
    <Stack gap={1}>
      {(!point || !item.area || !item.projection) && (
        <Alert severity='warning'>{`This damage wasn't marked on the visual modal.`}</Alert>
      )}

      <VisualModelSvgViewer
        visualModelId={damageDetection.vehicleVisualModel?.id}
        visualModel={undefined}
        imageSelector={{
          area: item.area || VehicleArea.Exterior,
          projection: item.projection || VehicleProjection.Front,
        }}
        points={point ? [point] : []}
        svgViewerProps={{
          defaultPointStyle: VehicleVisualModelHelper.defaultSvgPointStyleForDamage,
          isZoomEnabled: true,
          isResizeEnabled: true,
          isPointDragEnabled: false,
          ...visualModelSvgViewerProps?.svgViewerProps,
        }}
        {...visualModelSvgViewerProps}
      />
    </Stack>
  );
}
